export class EventUser {
  email: String;
  hasInfo: Boolean;
  hasCategory: Boolean;
  hasAdmin: Boolean;
  hasLive: Boolean;
}
